import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  conditionsAcceptedName,
  RegulationAcceptanceProps
} from 'pages/account/Register/pages/Main/steps/components/RegulationAcceptance';
import { RootState } from 'storage/store';

import AcceptRegulationsWithInfoView from './AcceptRegulationsWithInfoView';

const AcceptRegulationsWithInfo = <T,>() => {
  const { regulationsAcceptanceRequired } = useSelector(
    (state: RootState) => state.user
  );
  const formikContext = useFormikContext() as RegulationAcceptanceProps<T>;
  const { setFieldValue } = formikContext;
  useEffect(() => {
    if (regulationsAcceptanceRequired) {
      setFieldValue(conditionsAcceptedName, false);
    }
  }, [regulationsAcceptanceRequired]);

  if (!regulationsAcceptanceRequired) {
    return null;
  }
  return <AcceptRegulationsWithInfoView {...formikContext} />;
};

export default AcceptRegulationsWithInfo;
